import Vue from "vue";
export default {
  namespaced: true,

  state: {
    tituloGeneral: '',
    wizarData: [
      {
        num: 1,
        name: "Información de la evaluación",
        component: "InformacionComp",
        data: {},
        class: "",
        validar: true,
        validarText: "- Completar campos -",
      },
      {
        num: 2,
        name: "Agregar preguntas",
        component: "PreguntasComp",
        data: {},
        class: "",
        validar: true,
        validarText: "- Seleccionar preguntas -",
      },
      {
        num: 3,
        name: "Asociar competencias",
        component: "CompetenciasComp",
        data: {},
        class: "",
        validar: true,
        validarText: "- Seleccionar desempeños -",
      },
      {
        num: 4,
        name: "Asignar estudiantes",
        component: "AlumnosComp",
        data: {},
        class: "",
        validar: true,
        validarText: "- Seleccionar alumnos -",
      },
    ],
    evaluacionInformacion: {},
    listaPreguntasArray: [],
    evaluacionCompetencias: {},
    evaluacionAlumnos: {},
  },
  getters: {
    formValidados: (state) => {
      return state.wizarData.every((item) => item.validar);
    },
  },
  mutations: {
    limpiarWizarData(state){
      state.evaluacionInformacion = {};
      state.listaPreguntasArray = [];
      state.evaluacionCompetencias = {};
      state.evaluacionAlumnos = {};
    },
    setTitle(state, string) {
      state.tituloGeneral = string;
    },
    setdataWizard(state, array) {
      state.wizarData = array;
    },
    actualizaFormValido(state, { index, value }) {
      Vue.set(state.wizarData[index], "validar", value);
    },
    actualizaTitulossWizard(state, { index, title }) {
      Vue.set(state.wizarData[index], "name", title);
    },
    setFormEval(state, object) {
      state.evaluacionInformacion = object;
    },
    setlistaPreguntas(state, array) {
      state.listaPreguntasArray = array;
    },
    setPushlistaPreguntas(state, array) {
      state.listaPreguntasArray.push(array);
    },
    setlistaCompetencias(state, object) {
      state.evaluacionCompetencias = object;
    },
    setEvalAlumnos(state, object) {
      state.evaluacionAlumnos = object;
    },
  },

  actions: {
    async validateForm({ commit }, { index, value }) {
      commit("actualizaFormValido", { index, value });
    },
    async changeTituloStep({ commit }, { index, title }) {
      commit("actualizaTitulossWizard", { index, title });
    },
  },
};
